import React from "react";

const VendorInvitationThankYou = ({ isUpdate = false }) => {
    return (
        <main className="relative flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-br from-[#fff1e7] via-white to-[#eef0ff] px-4 py-8 text-[#172033]">
            <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[#f45b12]/10 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-32 -right-24 h-80 w-80 rounded-full bg-[#405bd5]/10 blur-3xl" />
            <section className="thank-you-card relative w-full max-w-2xl rounded-3xl border border-[#f1d6c6] bg-white px-6 py-10 text-center shadow-[0_20px_60px_rgba(35,42,58,0.12)] sm:px-12 sm:py-14">
                <div className="success-mark mx-auto mb-6 flex h-24 w-24 items-center justify-center">
                    <span className="success-mark__halo absolute h-24 w-24 rounded-full border border-[#f45b12]/30" />
                    <span className="success-mark__ring absolute h-20 w-20 rounded-full border-2 border-[#f45b12]/20" />
                    <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-[#f45b12] text-white shadow-[0_10px_25px_rgba(244,91,18,0.3)]">
                        <svg viewBox="0 0 32 32" className="h-9 w-9" fill="none" aria-hidden="true">
                            <path className="success-mark__check" d="M8 16.5 13.5 22 24.5 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                </div>
                <img
                    src="/logos/Neevay_Logo.png"
                    alt="Neevay"
                    className="thank-you-content mx-auto mb-8 h-auto w-[100px]"
                />
                <h1 className="thank-you-content text-2xl font-bold tracking-tight sm:text-2xl">
                    {isUpdate ? "Thank you for updating your profile." : "Thank you for submitting your profile."}
                </h1>
                <p className="thank-you-content mx-auto mt-4 max-w-lg text-sm leading-7 text-[#667085]">
                    {isUpdate ? "Your updated profile has been submitted and is awaiting for approval." : "Your profile has been submitted successfully!"}
                </p>
                <div className="mx-auto mt-8 h-1 w-16 rounded-full bg-gradient-to-r from-[#f45b12] to-[#405bd5]" />
                {/* <p className="thank-you-content mt-6 text-sm text-[#8a6b5b]">
                    You may close this window now.
                </p> */}
            </section>
            <style>{`
                .thank-you-card { animation: thank-you-card-in 600ms cubic-bezier(.22, 1, .36, 1) both; }
                .thank-you-content { animation: thank-you-content-in 500ms ease-out 250ms both; }
                .success-mark__halo { animation: success-halo 1.8s ease-out 450ms infinite; }
                .success-mark__ring { animation: success-ring 650ms cubic-bezier(.22, 1, .36, 1) 250ms both; }
                .success-mark__check { stroke-dasharray: 30; stroke-dashoffset: 30; animation: success-check 500ms cubic-bezier(.65, 0, .35, 1) 550ms forwards; }
                @keyframes thank-you-card-in { from { opacity: 0; transform: translateY(18px) scale(.98); } to { opacity: 1; transform: translateY(0) scale(1); } }
                @keyframes thank-you-content-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
                @keyframes success-ring { from { opacity: 0; transform: scale(.55); } to { opacity: 1; transform: scale(1); } }
                @keyframes success-check { to { stroke-dashoffset: 0; } }
                @keyframes success-halo { 0%, 35% { opacity: .65; transform: scale(.85); } 70%, 100% { opacity: 0; transform: scale(1.35); } }
                @media (prefers-reduced-motion: reduce) {
                    .thank-you-card, .thank-you-content, .success-mark__halo, .success-mark__ring, .success-mark__check { animation: none; }
                    .success-mark__check { stroke-dashoffset: 0; }
                }
            `}</style>
        </main>
    );
};

export default VendorInvitationThankYou;
